import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import styles from './common-button.css';

const Button = (props) => {
    const { children, onClick, modifier, type, tertiary, alternateColor, to, href, OpenNewTab, ...other } = props;

    const classList = `${modifier || ''} ${styles.button}
                        ${alternateColor ? styles['button--alternate-color'] : ''}
                        ${tertiary ? styles['button--tertiary'] : ''}`;

    if (href) {
        if (OpenNewTab) {
            return (
                <a
                    className={classList}
                    target="_blank"
                    {...{
                        onClick,
                        type,
                        href,
                        ...other
                    }}
                >
                    {children}
                </a>
            );
        }
        return (
            <a
                className={classList}
                {...{
                    onClick,
                    type,
                    href,
                    ...other
                }}
            >
                {children}
            </a>
        );
    }

    if (to) {
        return (
            <Link
                className={classList}
                {...{
                    onClick,
                    type,
                    to,
                    ...other
                }}
            >
                {children}
            </Link>
        );
    }

    return (
        <button
            className={classList}
            {...{
                onClick,
                type,
                ...other
            }}
        >
            {children}
        </button>
    );
};

Button.propTypes = {
    onClick: PropTypes.func,
    modifier: PropTypes.string,
    type: PropTypes.string,
    arrow: PropTypes.bool,
    alternateColor: PropTypes.bool,
    OpenNewTab: PropTypes.bool
};

Button.defaultProps = {
    arrow: false,
    alternateColor: false
};

export default Button;

